import React from 'react';
import { Grid, Switch, RadioGroup, Radio, FormControlLabel } from '@material-ui/core';
import styles from '../analytics.module.css';
import commonStyles from '../../common/common.module.css';
import { Chart as ChartJS, registerables, ChartData, ChartOptions } from 'chart.js';
import MaterialTable, { Column } from 'material-table';

import Paper from '@material-ui/core/Paper';
import file from '../../../assets/excelFile.svg'
import orderChecked from '../../../assets/analytics/orderChecked.svg'
import orderCheck from '../../../assets/analytics/orderCheck.svg'
import cwaitChecked from '../../../assets/analytics/cwaitChecked.svg'
import cwaitCheck from '../../../assets/analytics/cwaitCheck.svg'
import cprosChecked from '../../../assets/analytics/cprosChecked.svg'
import cprosCheck from '../../../assets/analytics/cprosCheck.svg'
import hwaitChecked from '../../../assets/analytics/hwaitChecked.svg'
import hwaitCheck from '../../../assets/analytics/hwaitCheck.svg'
import hprosChecked from '../../../assets/analytics/hprosChecked.svg'
import hprosCheck from '../../../assets/analytics/hprosCheck.svg'
import { Chart } from 'react-chartjs-2';
import { CustomerWaitGraphData } from '../../../models/Analytics';
ChartJS.register(...registerables);

interface graphDataViewProps {
  avgData: Array<any>;
  graphData: CustomerWaitGraphData;
  dataView: boolean;
  intvl: number;
  day_diff: number;
  handleChange: (type: string, event: any) => void;
  handleChangeDataView: (value: boolean) => void;
  handleExport: () => void;
};

const label = {
  Orders: 'Orders',
  Counter_Wait_Time: 'Waiting For Service',
  Counter_Process_Time: 'Counter Process Time',
  Whse_Wait_Time: 'W/hse Wait Time',
  Whse_Process_Time: 'W/hse Process Time'
}

const labelColor = {
  Orders: 'rgb(217,0,27)',
  Counter_Wait_Time: 'rgb(250,205,145)',
  Counter_Process_Time: 'rgb(0,50,94)',
  Whse_Wait_Time: 'rgb(170,170,170)',
  Whse_Process_Time: 'rgb(102,185,84)'
}

let graphOptions: ChartOptions = {
  plugins: {
    title: {
      display: true,
      text: 'Absolute',
    },
    datalabels:{
      display: false,
    },
    legend: {
      fullSize: true,
      display: true,
      labels: {
        padding: 20,
        usePointStyle: true,
        generateLabels: function (chart) {
          const labels = ChartJS.defaults.plugins.legend.labels.generateLabels(chart);

          for (var key in labels) {
            switch (labels[key].text) {
              case label.Orders:
                let orderCheckedYes = new Image(32, 14)
                let orderCheckNo = new Image(32, 14)
                orderCheckedYes.src = orderChecked
                orderCheckNo.src = orderCheck
                labels[key].pointStyle = labels[key].hidden ? orderCheckNo : orderCheckedYes
                break;
              case label.Counter_Wait_Time:
                let cwaitCheckedYes = new Image(32, 14)
                let cwaitCheckNo = new Image(32, 14)
                cwaitCheckedYes.src = cwaitChecked
                cwaitCheckNo.src = cwaitCheck
                labels[key].pointStyle = labels[key].hidden ? cwaitCheckNo : cwaitCheckedYes
                break;
              case label.Counter_Process_Time:
                let cprosCheckedYes = new Image(32, 14)
                let cprosCheckNo = new Image(32, 14)
                cprosCheckedYes.src = cprosChecked
                cprosCheckNo.src = cprosCheck
                labels[key].pointStyle = labels[key].hidden ? cprosCheckNo : cprosCheckedYes
                break;
              case label.Whse_Wait_Time:
                let hwaitCheckedYes = new Image(32, 14)
                let hwaitCheckNo = new Image(32, 14)
                hwaitCheckedYes.src = hwaitChecked
                hwaitCheckNo.src = hwaitCheck
                labels[key].pointStyle = labels[key].hidden ? hwaitCheckNo : hwaitCheckedYes
                break;
              case label.Whse_Process_Time:
                let hprosCheckedYes = new Image(32, 14)
                let hprosCheckNo = new Image(32, 14)
                hprosCheckedYes.src = hprosChecked
                hprosCheckNo.src = hprosCheck
                labels[key].pointStyle = labels[key].hidden ? hprosCheckNo : hprosCheckedYes
                break;
              default:
                break;

            }
            labels[key].fontColor = '#000'
          }
          return labels;
        }
      }
    },
  },
  responsive: true,
  scales: {
    x: {
      title: {
        display: true,
        text: 'Time Frame' as const,
        color: '#000'
      },
      stacked: true,
      grid: {
        borderColor: '#000',
        drawOnChartArea: false,
      },
      ticks: {
        color: '#000'
      },
    },
    y: {
      stacked: true,
      grid: {
        borderColor: '#000',
        drawOnChartArea: false,
      },
      title: {
        display: true,
        text: 'Mins' as const,
        color: '#000'
      },
      ticks: {
        color: '#000'
      },
    },
    y1: {
      title: {
        display: true,
        text: 'Numbner of Orders' as const,
        color: '#000'
      },
      type: 'linear' as const,
      display: true,
      position: 'right' as const,
      ticks: {
        stepSize: 1,
        color: '#000'
      },
      grid: {
        borderColor: '#000',
        drawOnChartArea: false,
      }
    },
  },
};

const GraphDataView = (props: graphDataViewProps) => {
  let columns: Column<object>[] = [
    {
      title: 'Measure', field: '0', type: 'numeric', cellStyle: { textAlign: 'left' }
    }
  ];
  if (graphOptions && graphOptions.plugins && graphOptions.plugins.title && props.day_diff > 1) {
    graphOptions.plugins.title.text = 'Average'
  }
  let cstart = 0;
  let field = 1;
  while (cstart < 24) {
    columns.push({
      title: cstart + '-' + (cstart + props.intvl), field: field.toString(), type: 'numeric', cellStyle: { textAlign: 'center' },
    });
    cstart = cstart + props.intvl;
    field++;
  }
  const getData = (): ChartData => {
    let labels = [];
    let start = 0;
    while (start < 24) {
      labels.push(start + '-' + (start + props.intvl));
      start = start + props.intvl;
    }
    return {
      labels,
      datasets: [
        {
          barPercentage: 0.4,
          label: 'Waiting For Service',
          data: props.graphData.cont_wait,
          backgroundColor: 'rgb(250,205,145)',
        },
        {
          barPercentage: 0.4,
          label: 'Counter Process Time',
          data: props.graphData.cont_pros,
          backgroundColor: 'rgb(0,50,94)',
        },
        // {
        //   barPercentage: 0.4,
        //   label: 'W/hse Wait Time',
        //   data: props.graphData.whse_wait,
        //   backgroundColor: 'rgb(170,170,170)',
        // },
        {
          barPercentage: 0.4,
          label: 'W/hse Process Time',
          data: props.graphData.whse_pros,
          backgroundColor: 'rgb(102,185,84)',
        },
        {
          label: 'Orders',
          data: props.graphData.orders,
          borderColor: 'rgb(217,0,27, .1)',
          backgroundColor: 'rgb(217,0,27)',
          type: 'line',
          order: -1,
          yAxisID: 'y1'
        }
      ],
    };
  };

  return (
    <div className={`${styles.customerGridItems}`}>
      <Grid container spacing={3} className={`${styles.wtOuterGridContainer}`}>
        <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
          <div className={`${commonStyles.fSpaceBtw} ${commonStyles.gap10} ${commonStyles.flexWrap}`}>
            <div>
              <small className={styles.switchLabel}>Graphical View</small>
              <Switch
                name="checkedA"
                inputProps={{ 'aria-label': 'secondary checkbox' }}
                color="primary"
                checked={props.dataView}
                onChange={() => {
                  props.handleChangeDataView(!props.dataView)
                }}
              />
              <small className={styles.switchLabel}>Data View</small>
            </div>
            <RadioGroup
              row
              aria-label="Interval"
              name="Interval"
              className={`${commonStyles.fMiddle} ${styles.cwtRadioGroup}`}>
              <small className={`${commonStyles.pr2}`}>Interval:</small>
              <FormControlLabel
                control={
                  <Radio
                    name="one_hr"
                    color="primary"
                    size="small"
                  />
                }
                name='intvl'
                checked={props.intvl === 1}
                label="1 Hr"
                onClick={() => props.handleChange('intvl', 1)}
              />
              <FormControlLabel
                control={
                  <Radio
                    name="two_hr"
                    color="primary"
                    size="small"
                  />
                }
                name='intvl'
                checked={props.intvl === 2}
                label="2 Hr"
                onClick={() => props.handleChange('intvl', 2)}
              />
              <FormControlLabel
                control={
                  <Radio
                    name="four_hr"
                    color="primary"
                    size="small"
                  />
                }
                name='intvl'
                checked={props.intvl === 4}
                label="4 Hr"
                onClick={() => props.handleChange('intvl', 4)}
              />
              <FormControlLabel
                control={
                  <Radio
                    name="eight_hr"
                    color="primary"
                    size="small"
                  />
                }
                name='intvl'
                checked={props.intvl === 8}
                label="8 Hr"
                onClick={() => props.handleChange('intvl', 8)}
              />
            </RadioGroup>
          </div>
          <div className={`${styles.wtOuterGridItems} ${styles.graphData}`} hidden={props.dataView}>
            <Chart options={graphOptions} data={getData()} type={'bar'} />
          </div>
          <div className={`${styles.wtOuterGridItems}`} hidden={!props.dataView}>
            <div className={`${styles.fileImg}`} onClick={() => props.handleExport()}>
              <img src={file} alt="file" />
            </div>
            <MaterialTable
              components={{ Container: props => <Paper {...props} elevation={0} className={`${commonStyles.paperTable} ${styles.anayTable}`} /> }}
              data={props.avgData && props.avgData[0] && (props.avgData[0].length - 1) == (24 / props.intvl) ? props.avgData : []}
              columns={columns}
              options={{
                paging: false,
                pageSize: 10,
                headerStyle: {
                  backgroundColor: 'var(--tbl_head_bkg)',
                  color: 'var(--tbl_head_color)',
                  zIndex: 2,
                  textAlign: 'center',
                  fontWeight: 600,
                },
                showTitle: false,
                pageSizeOptions: [15, 20],
                toolbar: false,
                sorting: false
              }}
            />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default GraphDataView;